export const SELECT_TOP_DEPARTMENT = 'SELECT_TOP_DEPARTMENT'
export const SELECT_CHILD_DEPARTMENT = 'SELECT_CHILD_DEPARTMENT'
export const SELECT_BUSINESS = 'SELECT_BUSINESS'
export const LOAD_TICKET_TYPE = 'LOAD_TICKET_TYPE'
export const SELECT_CHANNEL = 'SELECT_CHANNEL'
export const LOGGED_IN_USER = 'LOGGED_IN_USER';
export const PURCHASE_VIP = 'PURCHASE_VIP';
export const ADD_SCOIN = 'ADD_SCOIN';
export const PURCHASE_PACKAGE = 'PURCHASE_PACKAGE';
export const PURCHASE_DAY = 'PURCHASE_DAY';
export const PURCHASE_MEDIA = 'PURCHASE_MEDIA';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js